import(/* webpackMode: "eager" */ "/opt/actions-runner/_work/reservations/reservations/src/app/layout.tsx");
